import {motion} from 'framer-motion';
import { useState } from 'react';
import { Avatar, AvatarFallback } from 'components/ui/avatar';
import {  MoreVertical, Eye, Mail, Phone,
} from "lucide-react";
import { Button } from "components/ui/button";
import { useSelector } from 'react-redux';

const fadeIn = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.3 } },
};

const statusColor = (status: string) => {
  switch (status) {
    case "active": case "confirmed": case "completed":
      return "bg-emerald-50 text-emerald-700 border-emerald-200";
    case "pending":
      return "bg-amber-50 text-amber-700 border-amber-200";
    case "suspended": case "inactive":
      return "bg-red-50 text-red-700 border-red-200";
    default:
      return "bg-muted text-muted-foreground";
  }
};

const recentCustomers = [
  { id: "1", name: "Emily Watson", email: "emily@mail.com", phone: "+1 555-1001", joined: "Mar 2, 2026", bookings: 12, spent: "$480", status: "active", avatar: "EW" },
  { id: "2", name: "James Miller", email: "james@mail.com", phone: "+1 555-1002", joined: "Feb 28, 2026", bookings: 8, spent: "$320", status: "active", avatar: "JM" },
  { id: "3", name: "Lisa Chang", email: "lisa@mail.com", phone: "+1 555-1003", joined: "Mar 5, 2026", bookings: 3, spent: "$150", status: "active", avatar: "LC" },
  { id: "4", name: "Omar Hassan", email: "omar@mail.com", phone: "+1 555-1004", joined: "Jan 15, 2026", bookings: 0, spent: "$0", status: "inactive", avatar: "OH" },
  { id: "5", name: "Sarah Kim", email: "sarah@mail.com", phone: "+1 555-1005", joined: "Mar 8, 2026", bookings: 5, spent: "$210", status: "active", avatar: "SK" },
];

export default function Customers()  {
    // const {bookings} = useSelector(state => state.bookings)

    const [searchQuery, setSearchQuery] = useState("");
  const [customerFilter, setCustomerFilter] = useState("all");

  const filteredCustomers = recentCustomers.filter(c => {
    const matchesSearch = c.name.toLowerCase().includes(searchQuery.toLowerCase()) || c.email.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesFilter = customerFilter === "all" || c.status === customerFilter;
    return matchesSearch && matchesFilter;
  });
    return(
        <motion.div key="customers" {...fadeIn}>
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-foreground">Customers</h3>
                <div className="flex rounded-lg border border-border overflow-hidden">
                  {["all", "active", "inactive"].map((f) => (
                    <button key={f} onClick={() => setCustomerFilter(f)} className={`px-3 py-1.5 text-xs font-medium capitalize transition-colors ${customerFilter === f ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-muted"}`}>{f}</button>
                  ))}
                </div>
              </div>
              <div className="space-y-3">
                {filteredCustomers.map((c) => (
                  <motion.div key={c.id} variants={fadeIn} className="rounded-xl border border-border bg-background p-4">
                    <div className="flex items-center gap-3">
                      <Avatar className="h-12 w-12">
                        <AvatarFallback className="bg-muted text-muted-foreground text-sm font-medium">{c.avatar}</AvatarFallback>
                      </Avatar>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center justify-between">
                          <h4 className="font-semibold text-foreground">{c.name}</h4>
                          <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-medium ${statusColor(c.status)}`}>{c.status}</span>
                        </div>
                        <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mt-1 text-xs text-muted-foreground">
                          <span className="flex items-center gap-1"><Mail className="h-3 w-3" />{c.email}</span>
                          <span className="flex items-center gap-1"><Phone className="h-3 w-3" />{c.phone}</span>
                        </div>
                        <div className="flex items-center justify-between mt-3">
                          <div className="flex items-center gap-4 text-xs">
                            <span className="text-muted-foreground">Joined {c.joined}</span>
                            <span className="font-medium text-foreground">{c.bookings} bookings</span>
                            <span className="font-semibold text-primary">{c.spent} spent</span>
                          </div>
                          <div className="flex items-center gap-1">
                            <Button variant="ghost" size="icon" className="h-7 w-7"><Eye className="h-3.5 w-3.5" /></Button>
                            <Button variant="ghost" size="icon" className="h-7 w-7"><MoreVertical className="h-3.5 w-3.5" /></Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
    )
}